import { render } from "./ProductBest.vue?vue&type=template&id=353617a5"
import script from "./ProductBest.vue?vue&type=script&lang=js"
export * from "./ProductBest.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\iran\\iranrpm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__